import { createAction } from 'redux-actions';
export var LOCK_FORM = 'LOCK_FORM';
export var UNLOCK_FORM = 'UNLOCK_FORM';
// #todo: add tests
export var unlockForm = createAction(UNLOCK_FORM);
export var lockForm = createAction(LOCK_FORM);
